import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const DiplomaCivilEngineeringCoursePage: React.FC = () => {
  const courseData = {
    title: "Diploma in Civil Engineering",
    shortName: "DCE",
    duration: "3 years",
    description: "Technical program focused on construction, infrastructure development, and project management",
    overview: "Diploma in Civil Engineering is a 3-year technical program that provides comprehensive knowledge of construction technology, structural design, surveying, and infrastructure development. This course combines theoretical concepts with practical field experience, preparing students for careers in construction, public works, and infrastructure projects as skilled technicians and junior engineers.",
    eligibility: [
      "10th pass from recognized board",
      "Minimum 50% marks in 10th (45% for SC/ST)",
      "Mathematics and Science as compulsory subjects",
      "Good physical fitness for field work"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Engineering Mathematics",
          "Engineering Physics",
          "Engineering Chemistry",
          "Engineering Drawing",
          "Basic Civil Engineering",
          "Surveying Fundamentals"
        ]
      },
      {
        year: 2,
        subjects: [
          "Building Materials & Construction",
          "Structural Engineering",
          "Concrete Technology",
          "Highway Engineering",
          "Environmental Engineering",
          "Surveying & Levelling"
        ]
      },
      {
        year: 3,
        subjects: [
          "Project Management",
          "Estimation & Costing",
          "Water Resources Engineering",
          "Transportation Engineering",
          "Construction Management",
          "Industrial Training & Project"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Junior Civil Engineer",
        "Site Supervisor",
        "Survey Assistant",
        "Construction Inspector",
        "Quality Control Technician",
        "Project Coordinator",
        "CAD Operator",
        "Estimation Engineer",
        "Field Engineer",
        "Technical Assistant"
      ],
      industries: [
        "Construction Companies",
        "Infrastructure Development",
        "Government PWD",
        "Real Estate Companies",
        "Consulting Firms",
        "Railway Construction",
        "Highway Authorities",
        "Municipal Corporations",
        "Irrigation Departments",
        "Port & Airport Authorities"
      ],
      averageSalary: "₹2.5-5 LPA (Fresher), ₹6-18 LPA (Experienced)",
      topRecruiters: [
        "L&T Construction, Gammon",
        "NCC Limited, HCC",
        "Indian Railways, NHAI",
        "PWD Departments",
        "Tata Projects, Shapoorji Pallonji",
        "Municipal Corporations"
      ]
    },

    admissionProcess: [
      "State Polytechnic Entrance Test",
      "Merit-based admission on 10th marks",
      "Counselling and seat allotment",
      "Document verification",
      "College reporting and fee payment"
    ],

    topColleges: [
      {
        name: "Government Polytechnic College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Government College"
      },
      {
        name: "PSG Polytechnic College",
        location: "Coimbatore",
        fees: "₹45,000",
        ranking: "Private - NAAC A+"
      },
      {
        name: "Annamalai Polytechnic College",
        location: "Chidambaram",
        fees: "₹25,000",
        ranking: "University Affiliated"
      },
      {
        name: "Government Polytechnic",
        location: "Tiruchirappalli",
        fees: "₹18,000",
        ranking: "Government College"
      }
    ],

    skills: [
      "AutoCAD & Civil 3D",
      "Construction Planning",
      "Surveying Techniques",
      "Quality Testing",
      "Project Estimation",
      "Site Management",
      "Technical Drawing",
      "Material Testing",
      "Safety Management",
      "Cost Control"
    ],

    futureScope: "Growing opportunities in smart cities, green construction, sustainable infrastructure, and digital construction technologies with government's focus on infrastructure development.",

    faqs: [
      {
        question: "Can I become a licensed engineer with a Civil Engineering diploma?",
        answer: "While diploma holders can work as junior engineers, becoming a licensed Professional Engineer typically requires a degree. However, you can pursue B.Tech through lateral entry."
      },
      {
        question: "What are the government job opportunities?",
        answer: "Government jobs are available in PWD, Municipal Corporations, Railways, NHAI, Irrigation Department, and various PSUs for technical assistant and junior engineer positions."
      },
      {
        question: "Is field work mandatory in civil engineering?",
        answer: "Yes, civil engineering involves significant field work including site visits, surveying, and construction supervision. Some roles like design and estimation have less field work."
      },
      {
        question: "Can I start my own construction business?",
        answer: "Yes, many diploma holders start construction businesses, become contractors, or provide specialized services like surveying, estimation, or construction supervision."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default DiplomaCivilEngineeringCoursePage;
